export default "__VITE_ASSET__DQlIFJ$N__"